module.exports = __webpack_public_path__ + "img/Rectangle 10119.d737572a.svg";